module.exports = __webpack_public_path__ + "img/exit.acc92c42.svg";